/* eslint-disable func-style */
import { useEffect, useState } from 'react';


export async function hasMicrophoneAccess(deviceId: string): Promise<boolean> {
  try {
    const testStream = await navigator.mediaDevices.getUserMedia({
      audio: { deviceId: { exact: deviceId } },
    });
    testStream.getTracks().forEach(track => track.stop());
    return true;
  } catch {
    return false;
  }
}

export interface AudioInputReturn {
  audioDevices: MediaDeviceInfo[];
  selectedDevice: MediaDeviceInfo | null;
  errorMessage: string | null;
  setSelectedDevice: (device: MediaDeviceInfo) => void;
}

const ERROR_MESSAGE = 'Det er ikke muligt at få adgang til mikrofonen. Kontroller at du har givet tilladelse til at bruge mikrofonen.';

export function useAudioInput(): AudioInputReturn {
  const [audioDevices, setAudioDevices] = useState<MediaDeviceInfo[]>([]);
  const [selectedDevice, setSelectedDevice] = useState<MediaDeviceInfo | null>(null);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  useEffect(() => {
    const getAudioDevices = async () => {
      try {
        await navigator.mediaDevices.getUserMedia({
          audio: true,
        });
      } catch (error: any) {
        if (error.message.includes('Permission denied')) {
          console.error(ERROR_MESSAGE);
          setErrorMessage(ERROR_MESSAGE);
        }
        return;
      }

      navigator.mediaDevices.enumerateDevices().then(devices => {
        const audioInputs = devices.filter(x => x.kind === 'audioinput');
        setAudioDevices(audioInputs);
        if (audioInputs.length > 0) {
          setSelectedDevice(audioInputs[0]); // Default to the first device
        }
      });
    };

    getAudioDevices();
  }, []);

  return {
    audioDevices,
    selectedDevice,
    errorMessage,
    setSelectedDevice,
  };
}

export default useAudioInput;
